import { createRoot } from 'react-dom/client'
import './index.css'
import './App.css'
import App from './App.jsx'
import { Capacitor } from '@capacitor/core'

import * as Sentry from "@sentry/react";

// Only report to Sentry from real (production/preview) builds — local
// `npm run dev` sessions would otherwise send dev-only noise and errors
// into the shared production Sentry project.
if (import.meta.env.PROD && import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Performance Monitoring
    tracesSampleRate: import.meta.env.PROD ? 0.2 : 1.0, // Capture 20% in prod, 100% in dev
    // Session Replay
    replaysSessionSampleRate: import.meta.env.PROD ? 0.1 : 0, // 10% in prod
    replaysOnErrorSampleRate: 1.0, // 100% on errors
  });
}

try {
  const root = createRoot(document.getElementById('root'))
  root.render(<App />)
} catch (e) {
  console.error('Fatal Error Mounting React App:', e)
}

// Register PWA Service Worker (Web only - bypass on native platforms to prevent Appflow Deploy conflicts)
if ('serviceWorker' in navigator && import.meta.env.PROD && !Capacitor.isNativePlatform()) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('HomeEzi Service Worker registered: ', registration.scope);
      })
      .catch((registrationError) => {
        console.error('HomeEzi Service Worker registration failed: ', registrationError);
      });
  });
}
